import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './ProgressBar.module.scss'

const percentage = (done, total) => (total > 0 ? Math.round((done / total) * 100) : 0)

const ProgressBar = ({ done, total, label, thick = false, onDark = false, className }) => (
  <span className={classNames('d-flex align-items-center', classes.bar, { [classes.thick]: thick, [classes.onDark]: onDark }, className)}>
    <span className={classes.track}>
      <span className={classes.fill} style={{ width: `${percentage(done, total)}%` }} />
    </span>
    {label && <span className={classes.label}>{label}</span>}
  </span>
)

ProgressBar.propTypes = {
  done: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  label: PropTypes.node,
  thick: PropTypes.bool,
  onDark: PropTypes.bool,
  className: PropTypes.string,
}

export default ProgressBar
